module.exports = __webpack_public_path__ + "static/media/car-mechanic.011ce336.svg";